import moment from "moment";
import useGet from "../useGet";

const useDefaultRequiredDate = (deps: any[]) => {
  const { value, loading } = useGet(
    "/api/orders/_new/required-at-validity?ts=" + new Date().getTime(),
    "Unable to read the date required-at validation",
    null,
    deps
  );

  return {
    defaultRequiredDate:
      value && moment(value.defaultRequiredAt).format("DD/MM/YYYY"),
    defaultRequiredDateLoading: loading
  };
};

export default useDefaultRequiredDate;
